export const isWamTraceNavEnabled = () =>
  typeof window !== "undefined" && window.__WAM_TRACE_NAV__ === true;

export const traceWamNav = (label, payload = {}) => {
  if (!isWamTraceNavEnabled()) return;
  const entry = {
    ts: new Date().toISOString(),
    label,
    ...payload,
  };
  try {
    if (!Array.isArray(window.__WAM_TRACE_NAV_LOGS__)) {
      window.__WAM_TRACE_NAV_LOGS__ = [];
    }
    window.__WAM_TRACE_NAV_LOGS__.push(entry);
  } catch {}
  try {
    console.log("[WAM_TRACE_NAV]", entry);
    console.trace("[WAM_TRACE_NAV_STACK]", label);
  } catch {}
};
